// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__TKMSo","notes":"Notes_notes__1GFZE"};